__turbopack_context__.v({
  "content": "yeTb2G_content",
  "inner": "yeTb2G_inner",
  "liquidMetal": "yeTb2G_liquidMetal",
  "root": "yeTb2G_root",
});
